// Transitions
export const AMC_FORM_VALID_TRANSITION_BASIC_DETAILS = "allSureMotorClaim/basicDetails/transition/formValid";
export const AMC_FORM_INVALID_TRANSITION_BASIC_DETAILS = "allSureMotorClaim/basicDetails/transition/formInvalid";

export const AMC_RESET_STATE_TRANSITION_BASIC_DETAILS = "allSureMotorClaim/basicDetails/transition/resetState";

export const AMC_BASIC_DETAILS = "allSureMotorClaim/basicDetails/";
export const AMC_BASIC_DETAILS_SET_VALUE = AMC_BASIC_DETAILS+"setValue/";
export const AMC_BASIC_DETAILS_SET_VALID = AMC_BASIC_DETAILS +"setValid/";
export const AMC_BASIC_DETAILS_EDIT = AMC_BASIC_DETAILS +"setEdit";


//action
export const transitionBasicDetails = {
  formValid: () => ({ type: AMC_FORM_VALID_TRANSITION_BASIC_DETAILS }),
  formInvalid: () => ({ type: AMC_FORM_INVALID_TRANSITION_BASIC_DETAILS }),
};

export const resetPurchasePersonalDetails = () => ({
  type: AMC_RESET_STATE_TRANSITION_BASIC_DETAILS,
});

export const setBasicDetailsFieldValue =(value)=>({type: AMC_BASIC_DETAILS_SET_VALUE, value})
export const setBasicDetailsFieldValid =(error,fieldType)=>({type: AMC_BASIC_DETAILS_SET_VALID, error, fieldType})
export const setBasicDetailsEdit =(value)=>({type: AMC_BASIC_DETAILS_EDIT, value})


export const AMC_BASIC_DETAILS_SET_VALUE_WITHOUT_VALIDATION = AMC_BASIC_DETAILS+"withoutValidation/setValue";
export const setAmcBasicDetailsWithoutValidation =(value)=>({type: AMC_BASIC_DETAILS_SET_VALUE_WITHOUT_VALIDATION, value})
